import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { profile } from '../mock';

const NEAR_RADIUS = 220;

export default function HeroSection() {
  const servicesRef = useRef(null);
  const storeRef = useRef(null);
  const [nearServices, setNearServices] = useState(false);
  const [nearStore, setNearStore] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handle = (e) => {
      const mx = e.clientX;
      const my = e.clientY;
      const check = (ref, setter) => {
        if (!ref.current) return;
        const r = ref.current.getBoundingClientRect();
        const cx = r.left + r.width / 2;
        const cy = r.top + r.height / 2;
        const dx = mx - cx;
        const dy = my - cy;
        const dist = Math.sqrt(dx * dx + dy * dy);
        setter(dist < NEAR_RADIUS);
      };
      check(servicesRef, setNearServices);
      check(storeRef, setNearStore);
    };
    window.addEventListener('mousemove', handle);
    return () => window.removeEventListener('mousemove', handle);
  }, []);

  // Touch device fallback: tap to reveal
  const toggleSector = (which) => {
    if (which === 'services') { setNearServices(true); setNearStore(false); }
    else { setNearStore(true); setNearServices(false); }
  };

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.offsetTop - 40, behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="section"
      style={{
        minHeight: '100vh',
        padding: '0 32px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <div className="grid-lines" />

      {/* Top-left: signal active */}
      <div
        className="mono hero-signal"
        style={{
          position: 'absolute',
          top: 36,
          left: 36,
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '8px 12px',
          borderRadius: 999,
          background: 'rgba(8,8,8,0.5)',
          border: '1px solid rgba(245,245,245,0.08)',
        }}
      >
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: 99,
            background: '#f5f5f5',
            boxShadow: '0 0 10px #f5f5f5',
          }}
          className="blink"
        />
        <span style={{ fontSize: 9, color: 'rgba(245,245,245,0.65)', letterSpacing: '0.3em' }}>
          SIGNAL ACTIVE
        </span>
      </div>

      {/* Top-right: coords (hidden on mobile to avoid overlap) */}
      <div
        className="mono hero-coords"
        style={{
          position: 'absolute',
          top: 36,
          right: 36,
          fontSize: 9,
          letterSpacing: '0.28em',
          color: 'rgba(245,245,245,0.55)',
          padding: '8px 12px',
          borderRadius: 999,
          background: 'rgba(8,8,8,0.5)',
          border: '1px solid rgba(245,245,245,0.08)',
        }}
      >
        12.9716°N · 77.5946°E
      </div>

      {/* Name */}
      <div style={{ textAlign: 'center', zIndex: 3 }}>
        <h1 className="hero-name">LIKITH</h1>
        <div
          className="hero-caption"
          style={{
            marginTop: 18,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
          }}
        >
          <span
            style={{
              width: 6,
              height: 6,
              background: '#f5f5f5',
              borderRadius: 99,
            }}
            className="blink"
          />
          {profile.caption}
        </div>
      </div>

      {/* Sectors */}
      <div
        className="hero-sectors"
        style={{
          marginTop: 96,
          display: 'flex',
          alignItems: 'center',
          gap: 240,
          zIndex: 3,
        }}
      >
        <div
          ref={servicesRef}
          className={`sector ${nearServices ? 'near' : ''}`}
          onClick={() => scrollTo('services')}
          onTouchStart={() => toggleSector('services')}
          onDoubleClick={() => navigate('/services')}
          role="button"
          aria-label="Services"
        >
          <span className="sector-label">Services</span>
          <div className="loader" />
        </div>

        <div className="sector-divider" />

        <div
          ref={storeRef}
          className={`sector ${nearStore ? 'near' : ''}`}
          onClick={() => scrollTo('store')}
          onTouchStart={() => toggleSector('store')}
          onDoubleClick={() => navigate('/store')}
          role="button"
          aria-label="Store"
        >
          <span className="sector-label">Store</span>
          <div className="loader" />
        </div>
      </div>

      {/* Scroll hint */}
      <div
        className="mono"
        style={{
          position: 'absolute',
          bottom: 36,
          left: '50%',
          transform: 'translateX(-50%)',
          fontSize: 10,
          letterSpacing: '0.3em',
          color: 'rgba(245,245,245,0.4)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
          textAlign: 'center',
        }}
      >
        <span>SCROLL {'\u00b7'} OR PRESS {'\u2193'}</span>
        <span
          style={{
            width: 1,
            height: 32,
            background:
              'linear-gradient(180deg, rgba(245,245,245,0.5), transparent)',
          }}
        />
      </div>
    </section>
  );
}
